import React from 'react'

function Documentation() {
    return (
        <div className="container my-5"><h3 id="zoom-integration-documentation">Zoom Integration Documentation</h3>
        <h3 id="overview">Overview</h3>
        <p>The Zoom integration built by Sutra allows us automatically generate a Zoom meeting link when hosting a class on Sutra. It also automatically adds registrants to a meeting once that registrant has paid. This removes the effort of manually adding registrants to your meeting when they pay you outside of the Zoom application.</p>
        <h3 id="prerequisites">Prerequisites</h3>
        <ul>
        <li><p>Any Zoom account</p>
        </li>
        <li><p>Paid Zoom account if class is over 40 minutes</p>
        </li>
        <li><p>Sutra verified instructor account</p>
        </li>
        </ul>
        <h3 id="limitations">Limitations</h3>
        <p>You can only connect one Zoom account at a time.</p>
        <h3 id="installing-sutra-from-the-zoom-marketplace">Installing Sutra from the Zoom Marketplace</h3>
        <p>You can not install Sutra directly from the Zoom marketplace. You must first create a Sutra account and get verified by our team as a certified fitness instructor.</p>
        <p>1. Create an account and contact us at hello@sutra.fit to become a verified instructor</p>
        <p>2. After becoming a verified instructor, follow the steps to install Zoom from Sutra</p>
        <h3 id="installing-zoom-from-sutra">Installing Zoom from Sutra</h3>
        <p>1. Login to your Sutra Dashboard and click on the Integrations tab</p>
        <p>2. Under the Zoom card click on Connect</p>
        <p>3. Authorize Sutra to connect to your Zoom account</p>
        <p>4. You will be redirected to Sutra</p>
        <p>5. You&#39;re good to go!</p>
        <h3 id="step-by-step-usage-instructions-how-to-use-the-zoom-integration-within-the-sutra-dashboard">Step by Step Usage Instructions - How to use the Zoom integration within the Sutra Dashboard</h3>
        <p>Prerequisites: In order to use our Zoom feature you need a Zoom account connected to your instructor verified account.</p>
        <p>1. Make sure your Zoom account is connected to your Sutra account (please follow the steps &quot;Installing Zoom from Sutra&quot;)</p>
        <p>2. Go to the &quot;Home&quot; tab on the Sutra Dashboard</p>
        <p>3. Click on &quot;Add New&quot; to add a new class</p>
        <p>4. Fill out the form to create a new class</p>
        <p>5. When you get to the section &quot;Where is this hosted?&quot;, choose the Zoom option. When creating this class Sutra will automatically schedule a Zoom meeting.</p>
        <p>6. Save this class</p>
        <p>7. When students register for your class, they will be given a link to the Zoom meeting to join.</p>
        <p>8. When class is about to start the join link will appear in the homepage of your dashboard.</p>
        <h3 id="usage">Usage</h3>
        <p>1. Schedule Zoom meetings from the Sutra dashboard</p>
        <ul>
        <li><p>Description: The Zoom integration with Sutra allows Sutra users to easily create event pages for their Zoom meetings without having to manually add the meeting URL.</p>
        </li>
        <li><p>Prerequisites: Zoom account at any price tier</p>
        </li>
        </ul>
        <p>2. Retrieve cloud recordings for your Zoom meetings</p>
        <ul>
        <li><p>Description: The Zoom integration with Sutra allows Sutra users to easily retrieve their Zoom meeting cloud recordings</p>
        </li>
        <li><p>Prerequisites: Zoom account at the Pro pricing tier</p>
        </li>
        </ul>
        <p>‍</p>
        <h3 id="uninstalling-zoom">Uninstalling Zoom</h3>
        <p>1. Login in to your Sutra dashboard</p>
        <p>2. Click on the tab Integrations</p>
        <p>3. Click Disconnect on the Zoom card</p>
        <p>The Zoom integration built by Sutra allows Sutra to easily make class pages for the meetings in Zoom. It also automatically adds registrants to a meeting once that registrant has paid. This removes the effort of manually adding registrants to your meeting when they pay you outside of the Zoom application.</p>
        </div>
    )
}

export default Documentation